import { Stack, type StackProps } from '@ace-clublabs/shared-component-library';
import { forwardRef } from 'react';

export interface SearchContainerProps {
  children: React.ReactNode;
  sx?: StackProps['sx'];
  'data-testid'?: string;
  onBlur?: () => void;
  onFocus?: () => void;
}

const SearchContainer = forwardRef<HTMLDivElement, SearchContainerProps>(
  ({ children, sx, 'data-testid': dataTestId, onBlur, onFocus }, ref) => (
    <Stack
      ref={ref}
      direction='column'
      spacing={2}
      sx={[
        {
          backgroundColor: 'white',
          borderRadius: '12px',
          border: '1px solid',
          borderColor: 'grey.300',
          width: '100%',
          overflow: 'hidden',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      data-testid={dataTestId}
      onBlur={onBlur}
      onFocus={onFocus}
    >
      {children}
    </Stack>
  ),
);

export default SearchContainer;
